import React, { useState } from 'react';
import { TouchableWithoutFeedback } from 'react-native';

import { Form } from 'antd';
import cn from 'classnames';

import CountrySelect, { Flag } from '@components/CountrySelect'
import { Icon } from '@components/index'
import PWDValidateModal, { passwordValidator } from '@components/PWDValidateModal';
import RadioButton from '@components/RadioButton/RadioButton';
// import Image from 'next/legacy/image';
import { THEME, USER_AGREEMENT } from '@constants/index'
import { Button, Input, InputPassword, Popover } from '@element/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks';
import I18n from '@utils/i18n';

import styles from './index.module.css';
import registerStyles from '@styles/modules/register.module.css';

const FormItem = Form.Item;

export default function EmailRegister (props) {
  const { showInviteCode = true, btnText, btnClass, bottomClass, theme } = props
  const [form] = Form.useForm();
  const [isCollapse, setCollapse] = useState(false);

  useIsomorphicLayoutEffect(() => {
    if (props.initValue && form) {
      form.setFieldsValue({ email: props.initValue })
    }
    if (props.ic && form) {
      setCollapse(true)
      form.setFieldsValue({ inviteCode: props.ic })
    }
  }, [form, props])

  const handleSubmit = () => {
    const { email, password, inviteCode, country } = form.getFieldsValue()
    const params = {
      email,
      countryNum: country.telephoneCode,
      country: country.id,
      pwd: password, // TODO： 密码通过什么方式传到下几步？
      inviteCode
    };
    props.handleSubmit && props.handleSubmit(params);
  }

  function onToggleCollapse () {
    setCollapse(!isCollapse)
  }

  const onCountryChange = (option) => {
    form.setFieldsValue({
      country: {
        id: option.id,
        telephoneCode: option.telephoneCode
      }
    })
  }

  const onCountrySearch = (val) => {
    // console.log('search:', val);
  }

  return (
    <div className={registerStyles.container}>
      <Form
        name='basic'
        wrapperCol={{ span: 24 }}
        onFinish={handleSubmit}
        autoComplete='off'
        layout='vertical'
        form={form}
        initialValues={{
          remember: true,
          country: { id: 'HK', telephoneCode: '852' },
          email: '',
          password: '',
          isRadioChecked: false,
          inviteCode: ''
        }}
      >
        <div className={registerStyles.flexRow + ' mb8'}>
          <span className={registerStyles.countryCode}>
            <FormItem
              className={registerStyles.country}
              name='country'
            >
              <CountrySelect
                showCountryCode={true}
                onChange={onCountryChange}
                onSearch={onCountrySearch}
                selectBtnCalssName={styles.btn}
                theme={theme}
                renderValue={(params) => (
                  <Flag
                    nationalFlag={params?.nationalFlag}
                    flagIsImage={params?.flagIsImage}
                    className={registerStyles.nationalFlag}
                    imgW={28} imgH={21}
                  />
                )}
              />
            </FormItem>
          </span>
          <span className={registerStyles.mobile}>
            <FormItem
              className={registerStyles.email}
              name='email'
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                {
                  type: 'email',
                  message: I18n.t('register_email_err_fomat'),
                  validateTrigger: 'onBlur'
                },
                {
                  required: true,
                  message: I18n.t('register_email_err_fomat'),
                  validateTrigger: 'onChange'
                }
              ]}
            >
              <Input
                name='email'
                placeholder={I18n.t('register_input_email')}
                theme={theme}
                showClear={true}
                autocomplete="off"
              />
            </FormItem>
          </span>

        </div>
        <FormItem
          className='register-password-form'
          shouldUpdate
        >
          {(form) => {
            const { password } = form.getFieldsValue()
            return (
              <Popover
                placement="bottomLeft"
                content={(<PWDValidateModal password={password} theme={theme} />)}
                trigger='click'
                color='#fff'
              >
                <FormItem
                  name='password'
                  rules={[
                    ({ getFieldValue }) => ({
                      validator (_, value) {
                        return passwordValidator(value);
                      }
                    })
                  ]}
                >
                  <InputPassword
                    name='password'
                    type='password'
                    theme={theme}
                    placeholder={I18n.t('register_input_password')}
                    maxLength={20}
                    showClear={true}
                    autocomplete="new-password"
                  />
                </FormItem>
              </Popover>)
          }}
        </FormItem>

        {showInviteCode ? <TouchableWithoutFeedback TouchableWithoutFeedback onPress={onToggleCollapse}>
          <div className={registerStyles.inviteCode + ` ${isCollapse ? 'mb4' : 'mb48'}`}>
            <p className={cn(registerStyles.inviteCodeLabel, {
              [styles.darkInviteCodeLabel]: theme === THEME.DARK
            })}>{I18n.t('register_invitecode')}</p>
            <Icon className={cn(styles.arrow, {
              [styles.up]: isCollapse,
              [styles.down]: !isCollapse,
              [styles.darkArrow]: theme === THEME.DARK
            })} name="arrow-line" />
          </div>
        </TouchableWithoutFeedback> : null}
        {
          isCollapse
            ? <FormItem
              name='inviteCode'
              className='mb48'
            >
              <Input
                showClear={true}
                theme={theme}
                placeholder={I18n.t('register_input_invitecode')}
              />
            </FormItem>
            : null
        }
        <div className={bottomClass}>
        <FormItem shouldUpdate>
          {(form) => {
            const isRadioChecked = form.getFieldValue('isRadioChecked');
            return (
              <FormItem name="isRadioChecked" initialValue={false}>
                <RadioButton
                  isRadioChecked={isRadioChecked}
                  theme={theme}
                  onChange={() => {
                    form.setFieldsValue({ isRadioChecked: !isRadioChecked })
                  }}
                  radioText={I18n.t('register_agree_protocol')}
                  linkUrl={USER_AGREEMENT[I18n.locale]}
                  linkContent={<span className='DINPro'>{I18n.t('register_kiki_protocol')}</span>}
                  linkAfterContent={I18n.t('Kikitrade.policy')}
                />
              </FormItem>
            )
          }}
        </FormItem>
        <FormItem shouldUpdate>
          {(form) => {
            const { email, password, isRadioChecked } = form.getFieldsValue()
            const errors = form.getFieldsError(['email', 'password'])?.reduce((prev, curr) => {
              prev.push(...curr.errors)
              return prev;
            }, []);
            return (
              <Button
                type='primary'
                htmlType='submit'
                disabled={!(email && password && isRadioChecked && !errors.length)}
                loading={props.registering}
                className={btnClass}
                content={<span className={cn('Medium')}>{btnText || I18n.t('register')}</span>}
                data-buried="register"
                data-buried-type="register-email"
              />)
          }}
        </FormItem>
        </div>
      </Form>
    </div >
  )
}
